import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { appRoutes } from '../utils/app_routes'
import ShoppingBagIcon from '../assets/shopping_bag.svg'
import AppLogo from '../assets/logo.svg'
import Bars from '../assets/bars.svg';
import { useStore } from '../store/store'

const Header = () => {
    const { pathname } = useLocation()
    const { state: { sidebar }, dispatch } = useStore()
    return (
        <header className="h-[110px] w-full px-[4%] sm:px-[6%] xl:px-[10%] 2xl:px-[12.6%] flex justify-between items-center">
            <Link to={appRoutes.home} >
                <img src={AppLogo} alt="App Logo" className='h-[50px] sm:h-auto' />
            </Link>
            <div className="flex items-center gap-[50.5px]">
                {/* Desktop Menu */}
                <div className="hidden md:flex items-center gap-6 xl:gap-12">
                    <Link to={appRoutes.shop} className={`header-navs hover:text-primary ${pathname === appRoutes.shop ? "!text-primary " : ""}`}>Shop</Link>
                    <Link to={appRoutes.blog} className={`header-navs hover:text-primary ${pathname === appRoutes.blog ? "!text-primary " : ""}`}>Blog</Link>
                    <Link to={appRoutes.about} className={`header-navs hover:text-primary ${pathname === appRoutes.about ? "!text-primary " : ""}`}>About</Link>
                    <Link to={appRoutes.contact} className={`header-navs hover:text-primary ${pathname === appRoutes.contact ? "!text-primary " : ""}`}>Contact</Link>
                </div>
                {/* Bag Button */}
                <div className='flex items-center gap-2'>
                    <Link to={appRoutes.checkout} className="btn-primary flex gap-2 items-center">
                        <p>Bag</p>
                        <img src={ShoppingBagIcon} alt="Bag" className="h-5 w-5" />
                    </Link>
                    <button className='flex md:hidden w-10' onClick={() => dispatch({ type: "TOGGLE_SIDEBAR", payload: sidebar })}>
                        <img src={Bars} alt="Bars" className='h-[50px] ' />
                    </button>
                </div>
            </div>
        </header>

    )
}

export default Header